"use client";

import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
} from "@/components/ui/drawer";
import { useParams, useRouter } from "next/navigation";
import { PropsWithChildren, useState } from "react";

const ArticleDrawer = ({ children }: PropsWithChildren) => {
  const router = useRouter();
  const param = useParams();
  const [open, setOpen] = useState(true);

  async function handleClose() {
    (async () => {
      await new Promise((resolve) => setTimeout(resolve, 150));
      router.back();
    })();
  }

  return (
    <Drawer open={open} onClose={handleClose} onOpenChange={setOpen}>
      <DrawerContent className="mx-auto max-h-[90%] max-w-(--breakpoint-2xl)">
        <DrawerTitle className="hidden">{param.slug}</DrawerTitle>
        <DrawerDescription className="hidden">
          Article content
        </DrawerDescription>
        <div className="h-full overflow-y-auto p-4 pt-10 2xl:p-8">
          {children}
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export default ArticleDrawer;
